import { render, staticRenderFns } from "./taskEditForm.vue?vue&type=template&id=5e5e2756&scoped=true&"
import script from "./taskEditForm.vue?vue&type=script&lang=js&"
export * from "./taskEditForm.vue?vue&type=script&lang=js&"
import style0 from "./taskEditForm.vue?vue&type=style&index=0&id=5e5e2756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e2756",
  null
  
)

export default component.exports